/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Min_PriceInputs */

const en_cargos_min_price = /** @type {(inputs: Cargos_Min_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

const es_cargos_min_price = /** @type {(inputs: Cargos_Min_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio min`)
};

/**
* | output |
* | --- |
* | "Min price" |
*
* @param {Cargos_Min_PriceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_min_price = /** @type {((inputs?: Cargos_Min_PriceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Min_PriceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_min_price(inputs)
	return es_cargos_min_price(inputs)
});